import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { ReactNode } from 'react';

import { chipPropsBySettlementState } from '~components/Settlements/SettlementState';
import { useCompanyCurrency } from '~hooks/useCompanyCurrency/useCompanyCurrency';
import { Settlement } from '~hooks/useSettlements/models';

interface DetailRowProps {
  label: string;
  value: ReactNode;
}

const DetailRow = ({ label, value }: DetailRowProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
    <Typography
      variant="body2"
      sx={{
        color: 'text.secondary',
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        fontSize: 18,
      }}
    >
      {value}
    </Typography>
  </Box>
);

const RebillSettlementDetailsRow = ({ settlement }: { settlement?: Settlement }) => {
  const { currencyFormatter } = useCompanyCurrency();

  if (!settlement) {
    return null;
  }

  const { label: statusLabel } = chipPropsBySettlementState[settlement.state];

  const detailFields = [
    {
      label: t('approvals.driver_pay.settlements.void_settlement.settlement_id'),
      value: settlement.settlementId,
    },
    {
      label: t('approvals.driver_pay.settlements.pdf.for'),
      value: settlement.customerAccount?.name || '',
    },
    {
      label: t('form_fields.status'),
      value: String(statusLabel),
    },
    {
      label: t('approvals.driver_pay.settlements.pdf.total'),
      value: currencyFormatter(settlement.rebillTotalAmount ?? 0),
    },
  ];

  return (
    <Box
      sx={{
        my: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        {t(
          'approvals.driver_pay.settlements.rebill_adjustments.new_settlement_section_title',
        )}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          px: 2,
          py: 3,
        }}
      >
        {detailFields.map((field, index) => (
          <DetailRow key={index} label={field.label} value={field.value} />
        ))}
      </Box>
    </Box>
  );
};

export default RebillSettlementDetailsRow;
